import React from 'react';
import '../../styles/form.css';

export default function Input({ name, value, onChange, placeholder, className = '', type = 'text', ...props }) {
    return (
        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`input-field ${className}`}
            {...props}
        />
    );
}
